import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import {
  Badge,
  Box,
  ButtonSelect,
  Icon,
  MenuMulti,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { setAppliedRoleFilters } from '../../../../redux/certlist/action';
import { getMessageKey } from '../../../../utils/utils';

import './RoleFilter.css';

function RoleFilter({ isMobileXlargeWidth, isSearchBarExpanded }) {
  const [options, setOptions] = useState([]);
  const [showIcon, setShowIcon] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    setShowIcon(isMobileXlargeWidth);
  }, [isMobileXlargeWidth]);
  const dispatch = useDispatch();

  const {
    global: { isGlobalLoading },
    viewControls: { roleFilters, appliedRoleFilters },
    core: { isAdminLogin, totalItems: totalItemsCount },
    tabs: { activeTab, tabsCount },
  } = useSelector((state) => state?.certifications?.list);
  const { messages } = useSelector((state) => state?.user);
  // updates row filter options state

  useEffect(() => {
    if (!appliedRoleFilters) {
      setOptions(
        roleFilters.map((option) => ({
          ...option,
          label:
            messages[option.label] ||
            localize(intl, getMessageKey(option.label)),
          isChecked: false,
        }))
      );
    }
  }, [roleFilters, appliedRoleFilters]);

  /**
   *
   * @param {*} selectedOptions - Array of selected options
   * handles onchange of menu multi
   */
  const handleChange = (selectedOptions) => {
    setOptions(
      options.map((option) => ({
        ...option,
        isChecked: selectedOptions.some(
          (selectedOption) => selectedOption.value === option.value
        ),
      }))
    );
    dispatch(setAppliedRoleFilters(selectedOptions));
  };

  const countOfCheckedOptions = options?.filter(
    (option) => option?.isChecked
  )?.length;

  return (
    <Box className='RoleFilter'>
      <MenuMulti
        classNames={{
          dropdownClassName: 'RoleFilter-dropdown',
        }}
        className='RoleFilter-menumulti'
        options={options}
        onChange={handleChange}
        trigger={
          <ButtonSelect
            kind={showIcon && isSearchBarExpanded ? 'icon' : 'rectangle'}
            label=''
            size='medium'
            prefixIcon={
              showIcon && isSearchBarExpanded ? <Icon kind='Filter' /> : ''
            }
            BadgeComp={
              countOfCheckedOptions > 0 ? (
                <Badge kind='dot' color='primary' size='small' />
              ) : null
            }
            isDisabled={
              tabsCount[activeTab] === 0 ||
              totalItemsCount === 0 ||
              isGlobalLoading
            }
          />
        }
        label={
          isAdminLogin
            ? messages.CERTS_CERTIFIER_STATUS ||
              localize(intl, getMessageKey('CERTS_CERTIFIER_STATUS'))
            : messages.CERTS_ROLE || localize(intl, getMessageKey('CERTS_ROLE'))
        }
        sortOnCheck
        placement='bottom'
        minOptionsForFooter={0}
        minOptionsForSearch={10}
        appendLabelsToButton={false}
        footerLink1Text={
          messages.CERTS_LIST_SELECT_ALL ||
          localize(intl, getMessageKey('CERTS_LIST_SELECT_ALL'))
        }
        footerLink2Text={
          messages.CERTS_LIST_CLEAR ||
          localize(intl, getMessageKey('CERTS_LIST_CLEAR'))
        }
      />
    </Box>
  );
}

RoleFilter.propTypes = {
  isMobileXlargeWidth: PropTypes.bool,
};

RoleFilter.defaultProps = {
  isMobileXlargeWidth: false,
};

export default RoleFilter;
